import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcPlay32Icon } from '@gem/icons';

import { DeleteButton } from '../../components/DeleteButton/DeleteButton';
import { IItemMediaPresenter } from '../ItemMedia.presenter';
import styles from './MediaMessageVideo.styles.m.css';

interface IMediaMessageVideoProps {
  presenter: IItemMediaPresenter;
}

export const MediaMessageVideo: FC<IMediaMessageVideoProps> = observer(({ presenter }) => {
  return (
    <div className={styles.videoContainer}>
      <img
        src={presenter.previewUrl}
        className={styles.video}
        alt={presenter.name}
      />
      <div className={styles.iconContainer}>
        <IcPlay32Icon className={styles.icon} />
      </div>
      {presenter.canBeRemoved && (
        <DeleteButton
          onClick={presenter.onRemove}
          className={styles.delete}
        />
      )}
    </div>
  );
});
